export const style = {
  card: {
    width: '600px',
    margin: 'auto',
  },
  title: { fontSize: '20px' },
}
